import React, { useState } from 'react';
import { MailIcon, MessageSquareIcon, UserIcon } from 'lucide-react';
export function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Here you would typically send the form data to your backend
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    }, 3000);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  if (submitted) {
    return <div className="text-center py-12" data-id="element-350">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4" data-id="element-351">
          <MailIcon className="w-8 h-8 text-green-600" data-id="element-352" />
        </div>
        <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-353">
          ¡Mensaje Enviado!
        </h3>
        <p className="text-gray-600" data-id="element-354">
          Gracias por contactarnos. Te responderemos dentro de las próximas 24
          horas.
        </p>
      </div>;
  }
  return <div data-id="element-355">
      <p className="text-gray-600 mb-6" data-id="element-356">
        ¿Tienes alguna pregunta? Estamos aquí para ayudarte. Completa el
        formulario y te responderemos lo antes posible.
      </p>

      <form onSubmit={handleSubmit} className="space-y-4" data-id="element-357">
        <div data-id="element-358">
          <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-359">
            <UserIcon className="w-4 h-4 inline mr-2" data-id="element-360" />
            Nombre Completo
          </label>
          <input type="text" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent" placeholder="Tu nombre" data-id="element-361" />
        </div>

        <div data-id="element-362">
          <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-363">
            <MailIcon className="w-4 h-4 inline mr-2" data-id="element-364" />
            Email
          </label>
          <input type="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent" placeholder="tu@email.com" data-id="element-365" />
        </div>

        <div data-id="element-366">
          <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-367">
            <MessageSquareIcon className="w-4 h-4 inline mr-2" data-id="element-368" />
            Asunto
          </label>
          <select name="subject" value={formData.subject} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent" data-id="element-369">
            <option value="" data-id="element-370">Selecciona un asunto</option>
            <option value="soporte" data-id="element-371">Soporte Técnico</option>
            <option value="recetas" data-id="element-372">Consulta sobre Recetas</option>
            <option value="reembolso" data-id="element-373">Solicitud de Reembolso</option>
            <option value="sugerencia" data-id="element-374">Sugerencia o Feedback</option>
            <option value="otro" data-id="element-375">Otro</option>
          </select>
        </div>

        <div data-id="element-376">
          <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-377">
            Mensaje
          </label>
          <textarea name="message" value={formData.message} onChange={handleChange} required rows={6} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent resize-none" placeholder="Cuéntanos en qué podemos ayudarte..." data-id="element-378" />
        </div>

        <button type="submit" className="w-full bg-orange-600 text-white py-3 rounded-lg font-semibold hover:bg-orange-700 transition" data-id="element-379">
          ENVIAR MENSAJE
        </button>
      </form>

      <div className="mt-8 pt-8 border-t" data-id="element-380">
        <h4 className="font-bold text-gray-900 mb-4" data-id="element-381">
          Otras formas de contacto:
        </h4>
        <div className="space-y-2 text-gray-700" data-id="element-382">
          <p data-id="element-383">
            <strong data-id="element-384">Email:</strong>{' '}
            <a href="mailto:contactomikioscodigital@gmail.com" className="text-baby-blue hover:text-baby-blue-dark transition" data-id="element-385">
              contactomikioscodigital@gmail.com
            </a>
          </p>
          <p data-id="element-386">
            <strong data-id="element-387">Horario de atención:</strong> Lunes a Viernes, 9:00 - 18:00
            (GMT-5)
          </p>
          <p data-id="element-388">
            <strong data-id="element-389">Tiempo de respuesta:</strong> Menos de 24 horas
          </p>
        </div>
      </div>
    </div>;
}